/**
 * Mobile/tablet search layer (Lavazza):
 * - Opens on focus/click or search toggle (viewport ≤1024px)
 * - Full-screen layer below top banner; form moved into layer
 * - Suggestions relocated from AJAX wrapper when query length ≥ 3
 * - Most Popular categories from SearchServices-GetMostPopularCategories in editorial slot
 */
const COMPACT_MAX_WIDTH = 1024;
const COMPACT_MIN_CHARS = 3;
const mostPopularCategories = require('./mostPopularCategories');
const searchFieldUi = require('./searchFieldUi');

let $activeField = null;
let $siteSearchMount = null;
let $layerMount = null;

function isCompactViewport() {
	return $(window).width() <= COMPACT_MAX_WIDTH;
}

function isMobileSearchField($field) {
	if (!isCompactViewport()) {
		return false;
	}

	return !!$field.closest('#header-search-mobile').length
		|| !!$field.closest('.search-mobile-layer').length
		|| !!$field.closest('.main-header-bar .search').length;
}

function getLayer() {
	return $('.search-mobile-layer').first();
}

function getLayerInputMount() {
	return getLayer().find('.search-mobile-layer__input-mount');
}

function getLayerDynamic() {
	return getLayer().find('.search-mobile-layer__dynamic');
}

function getLayerEditorial() {
	return getLayer().find('.search-mobile-layer__editorial');
}

function isLayerOpen() {
	return $('html').hasClass('is-mobile-search-open');
}

function showEditorial() {
	return mostPopularCategories.loadIntoEditorial(getLayer(), getLayerEditorial());
}

function hideEditorial() {
	mostPopularCategories.hideEditorial(getLayerEditorial());
}

function updateBannerHeightVar() {
	const bannerHeight = $('#lvz-top-banner').height() || 0;
	$('html').css('--lvz-top-banner-height', `${bannerHeight}px`);
}

function notifyLayoutChange() {
	$(document).trigger('lavazza:headerSearchLayoutChange');
}

function syncToggleState() {
	$('.search-button-toggle').attr('aria-expanded', isLayerOpen() ? 'true' : 'false');
}

function mountLayerToBody() {
	const $layer = getLayer();
	if (!$layer.length || $layer.parent().is('body')) {
		return;
	}

	$layerMount = $layer.parent();
	$('body').append($layer);
}

function restoreLayerMount() {
	const $layer = getLayer();
	if ($layerMount && $layerMount.length && $layer.length) {
		$layerMount.append($layer);
	}

	$layerMount = null;
}

function moveSiteSearchToLayer($field) {
	const $siteSearch = $field.closest('.site-search');
	if (!$siteSearch.length || getLayerInputMount().find('.site-search').length) {
		return;
	}

	$siteSearchMount = $siteSearch.parent();
	$siteSearch.addClass('site-search--mobile');
	getLayerInputMount().append($siteSearch);
}

function restoreSiteSearch() {
	if (!$siteSearchMount || !$siteSearchMount.length) {
		return;
	}

	const $siteSearch = getLayerInputMount().find('.site-search');
	if ($siteSearch.length) {
		$siteSearch.removeClass('site-search--mobile');
		$siteSearchMount.append($siteSearch);
	}

	$siteSearchMount = null;
}

function resolveField($field) {
	if ($field && $field.length) {
		return $field;
	}

	return $('#header-search-mobile .search-field').first().length
		? $('#header-search-mobile .search-field').first()
		: $('.main-header-bar .search .search-field').first();

}

function open($field) {
	if (isLayerOpen()) {
		return;
	}

	const $resolved = resolveField($field);
	if (!$resolved.length || !isMobileSearchField($resolved)) {
		return;
	}

	$activeField = $resolved;
	updateBannerHeightVar();

	$('html').addClass('is-mobile-search-open');
	$('body').addClass('is-mobile-search-open');
	getLayer().removeClass('d-none').attr('aria-hidden', 'false');
	mountLayerToBody();
	$resolved.attr('aria-expanded', 'true');
	getLayerDynamic().empty();
	showEditorial();
	moveSiteSearchToLayer($resolved);
	notifyLayoutChange();
	syncToggleState();

	$resolved.trigger('focus');

	if (window.lavazzaGtm && window.lavazzaGtm.search) {
		window.lavazzaGtm.search.trackLayerOpen();
	}
}

function openFromToggle() {
	if (isCompactViewport()) {
		open($('#header-search-mobile .search-field').first());
	}
}

function close() {
	const wasOpen = isLayerOpen();

	$('html').removeClass('is-mobile-search-open');
	$('body').removeClass('is-mobile-search-open');
	restoreLayerMount();
	restoreSiteSearch();
	getLayer().addClass('d-none').attr('aria-hidden', 'true');
	getLayerDynamic().empty();
	hideEditorial();

	if ($activeField && $activeField.length) {
		$activeField.val('').attr('aria-expanded', 'false').blur();
		$activeField.siblings('.suggestions-wrapper').empty();
		searchFieldUi.syncResetButton($activeField);
	}

	$activeField = null;

	if (wasOpen) {
		notifyLayoutChange();
		syncToggleState();

		if (window.lavazzaGtm && window.lavazzaGtm.search) {
			window.lavazzaGtm.search.trackLayerClose();
		}
	}
}

function moveSuggestionsToLayer($wrapper) {
	if (!$wrapper.children().length) {
		return;
	}

	getLayerDynamic()
		.empty()
		.append($wrapper.children());

	$wrapper.empty();
}

function clearDynamicResults($field) {
	const $wrapper = $field.siblings('.suggestions-wrapper');
	$wrapper.empty();
	getLayerDynamic().empty();
	showEditorial();
}

function handleInput($field) {
	if (!isMobileSearchField($field)) {
		return;
	}

	if (!isLayerOpen()) {
		open($field);
		return;
	}

	if ($field.val().length < COMPACT_MIN_CHARS) {
		clearDynamicResults($field);
	}
}

function handleSuggestionsResponse($field) {
	if (!isLayerOpen() || !isMobileSearchField($field)) {
		return;
	}

	const queryLength = $field.val().length;
	const $wrapper = $field.siblings('.suggestions-wrapper');

	if (queryLength < COMPACT_MIN_CHARS) {
		clearDynamicResults($field);
		return;
	}

	moveSuggestionsToLayer($wrapper);
	const $dynamic = getLayerDynamic();
	const hasResults = $dynamic.find('.suggestions').length > 0
		&& !$dynamic.find('.suggestions--empty').length;

	if (hasResults) {
		hideEditorial();
	} else {
		showEditorial();
	}
}

function bindEvents() {
	$(document).on('click', '.main-header-bar .site-search', function (e) {
		const $field = $(this).find('.search-field').first();

		if (!isMobileSearchField($field) || $(e.target).closest('button, a').length) {
			return;
		}

		if (!isLayerOpen()) {
			open($field);
		}
	});

	$(document).on('focusin click', '.main-header-bar .search-field', function (e) {
		const $field = $(this);

		if (!isMobileSearchField($field)) {
			return;
		}

		if (e.type === 'click' && isLayerOpen()) {
			return;
		}

		if (!isLayerOpen()) {
			open($field);
		}
	});

	$(document).on('input', '.main-header-bar .search-field', function () {
		handleInput($(this));
	});

	$(document).on('click', '.search-mobile-close', function (e) {
		e.preventDefault();
		close();
	});

	$(document).on('keydown', function (e) {
		if (!isLayerOpen() || e.key !== 'Escape') {
			return;
		}

		e.preventDefault();
		close();
	});

	$(window).on('resize', function () {
		if (!isLayerOpen()) {
			return;
		}

		if (!isCompactViewport() || ($activeField && !isMobileSearchField($activeField))) {
			close();
		} else {
			updateBannerHeightVar();
		}
	});
}

module.exports = function initMobileSearch() {
	if (!getLayer().length) {
		return;
	}

	bindEvents();
};

module.exports.open = open;
module.exports.openFromToggle = openFromToggle;
module.exports.close = close;
module.exports.isOpen = isLayerOpen;
module.exports.isMobileSearchField = isMobileSearchField;
module.exports.isCompactViewport = isCompactViewport;
module.exports.getCompactMinChars = function () {
	return COMPACT_MIN_CHARS;
};
module.exports.handleSuggestionsResponse = handleSuggestionsResponse;
module.exports.clearDynamicResults = clearDynamicResults;
